import script from "./menustree.vue?vue&type=script&setup=true&name=menustree&lang=js"
export * from "./menustree.vue?vue&type=script&setup=true&name=menustree&lang=js"

import "./menustree.vue?vue&type=style&index=0&id=3aff9efc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3aff9efc"]])

export default __exports__